/* USE PROTECTION design: the search sheet (snippets/up-search.liquid), 1:1 the mockup's renderSheet():
   - empty (#cauta0): the vibe tiles and the most-searched cards are picked from the snippet's <template> for the
     visitor's face when the sheet opens (six moods with enough designs for that face, eight cards the gender lens
     lets through - the lens CSS in assets/up-skin.css would hide the rest anyway);
   - typing (#cautare): live results from the market's predictive search endpoint
     (data-suggest-url = routes.predictive_search_url + .json, resources[type]=product, resources[limit]=10), kept to
     the products that carry EVERY typed word in the title or the tags (the mockup's searchDesigns(), with its
     Romanian synonyms), one card per design (the part of the title before " - ", as everywhere), the list rules of
     every card surface, four snippets/up-card cards built here, the vibes whose name matches, the count of the
     designs found ("N designuri pentru <phone>"), "see all" to the search page (/search?q=);
   - nothing found: the mockup's 0, the popular searches and the most-searched rail.
   Phones: the predictive endpoint answers ten products at most, mostly the per-phone copies of a few designs, and it
   matches the words loosely (any of them). So every settled query asks twice, in parallel: the typed words alone, and
   the typed words plus one phone - the remembered one (assets/mf-device.js, localStorage mf_dev1), else the phone of
   the most-searched rail (data-ref-dev). From both answers only the products with every typed word count; with a
   remembered phone, that phone's product of each design ("pentru <phone>"); without one, the cards on one phone as far
   as the answers allow. A query that names a phone itself ("iphone 15", "s24 ultra") is never scoped to another one.
   Cards: the suggest JSON is product-level only, so the shown candidates are completed with ONE tokenless Storefront
   API query (GQL below, retried once): the collections (all-cases = the 1+1 chip, shown only when the visitor's price
   arm has 1+1 - window.__mfP11 from the dealer in layout/theme.liquid - and the exact hidden-collection rule) and the
   first available variant (the drop-height spec and the sale pill, as up-card computes them). If that query fails or
   is slow the card shows what the suggest JSON knows (no chip, no spec, the product-level sale pill).
   Measurement: assets/mf-track.js keeps measuring this sheet with its own listeners (query / qcat_* when the input is
   typed in, chip_click on the popular chips, studio_click - see the snippet). A popular chip runs its search without
   an input event, so it counts as chip_click only, as the live chips (links to /search) did. Only sheet_open is sent
   from here, through window.mfTrackPush.
   Accessibility: while the sheet is open Tab stays inside it, on close the focus goes back to the opener, and the
   openers carry aria-expanded.
   Words: the store's own, window.mfT('up.nav.*') (snippets/mf-l10n.liquid, rendered in <head> before this deferred
   file); counts pick the store language's plural form (Intl.PluralRules on <html lang>, keys <base>_one / _two / _few /
   _many / _other, an empty form falls back to _other). The drop-height spec and the 1+1 chip are keys too.
   ES5 on purpose (no build step; same as up.js and mf-track.js). */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.__upSearch) { return; }
  W.__upSearch = 1;

  /* true: with a remembered phone the results are that phone's products ("N designuri pentru <phone>"), and nothing
     for the phone = the phone-blind results. false = never scoped to the remembered phone (the live behaviour). */
  var DEVICE_SCOPE = true;
  var CARDS = 4, POPULAR = 8, VIBES = 6, WAIT = 250, ENRICH_WAIT = 1500;
  var DEV_TTL = 15552000000;   /* mf-device.js reads its record with the same 180-day TTL */
  /* the device part of a title: "Apple iPhone 17 Pro husă telefon" -> "Apple iPhone 17 Pro" (snippets/mf-dev-name) */
  var DEV_TAIL = /\s+(?:husă|Husă|folie|telefontok|kijelzővédő|etui|szkło|folia|kryt|ochranné|θήκη|προστατευτικό|калъф|протектор)(?:\s.*)?$/;
  var BRANDS = { apple: 1, samsung: 1, galaxy: 1, google: 1, huawei: 1, xiaomi: 1, redmi: 1, poco: 1, oneplus: 1,
    honor: 1, motorola: 1, oppo: 1, realme: 1, vivo: 1, asus: 1, nothing: 1 };
  /* a query that names a phone: mf-track's qcat_device and qcat_model rules, plus an S-model anywhere ("bear s24") */
  var DEV_WORDS = /(iphone|samsung|galaxy|huawei|xiaomi|redmi|oneplus|pixel|honor|oppo|realme|nothing|apple|motorola|poco)/i;
  var DEV_MODEL = /^s?\d{1,2}\s*(pro|max|plus|ultra|air|mini|fe)?\s*(max|plus)?$/i;
  var DEV_TOKEN = /(^|\s)s\d{2}(\+|e|fe|plus|ultra)?(\s|$)/i;
  /* the mockup's SYN: Romanian words for the design names */
  var SYN = { urs: 'bear', ursulet: 'bear', flori: 'flower', floare: 'flower', bani: 'money', inima: 'heart',
    inimi: 'heart', negru: 'black', argintiu: 'silver', cruce: 'cross', cruci: 'cross', cirese: 'cherry', ochi: 'eyes' };
  var GQL = '/api/2026-07/graphql.json';
  var GQL_FRAG = 'fragment U on Product { handle collections(first: 100) { nodes { handle } } ' +
    'variants(first: 30) { nodes { availableForSale price { amount } compareAtPrice { amount } selectedOptions { value } } } }';

  var cache = {}, extra = {}, seq = 0, timer = 0, lastOpen = 0, opener = null;

  /* the store words (snippets/mf-l10n.liquid); '' when a key is missing */
  function t(k, vars) { return W.mfT ? W.mfT(k, vars) : ''; }
  /* "N designs" in the store language: the CLDR plural form of n (ro: 1 one, 2-19 / 101-119 few, 20+ other) */
  function plural(base, n) {
    var cat = n === 1 ? 'one' : 'other';
    try { cat = new Intl.PluralRules(D.documentElement.lang || 'ro').select(n); } catch (e) {}
    return (t(base + '_' + cat) || t(base + '_other')).replace(/\[n\]/g, String(n));
  }

  function sheet() { return D.getElementById('search'); }
  function one(r, s) { return r ? r.querySelector(s) : null; }
  function trim(s) { return String(s == null ? '' : s).replace(/^\s+|\s+$/g, ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(t) {
    t = String(t || '').toLowerCase();
    try { t = t.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return trim(t.replace(/\s+/g, ' '));
  }
  function face() {
    var c = D.documentElement.classList;
    return c.contains('mf-g-women') ? 'w' : c.contains('mf-g-men') ? 'm' : 'a';
  }
  /* 1+1 follows the visitor's price arm (the dealer's __mfP11 and html.mf-p11-on), as the 1+1 band and picker do */
  function p11Arm() {
    /* the chip says 1+1: only on a 1+1 store (mf-store offer p11), never on a 2+2 one (multistore 2026-10-25) */
    if (W.__mfStore && W.__mfStore.offer && W.__mfStore.offer !== 'p11') return false;
    return W.__mfP11 ? W.__mfP11 === 'on' : D.documentElement.classList.contains('mf-p11-on');
  }

  /* ── phones ── */
  /* mf-device.js's canon(): lowercase alphanumerics, leading brand words dropped. Both sides of every comparison
     (the remembered label and the product titles) go through devKey() here, so they always agree. */
  function canon(t) {
    var x = trim(String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' '));
    if (!x) { return ''; }
    var parts = x.split(' '), i = 0;
    while (i < parts.length && BRANDS[parts[i]]) { i++; }
    var stripped = parts.slice(i).join('');
    return stripped.length >= 3 ? stripped : parts.join('');
  }
  /* "+" is part of the model, not punctuation: "Samsung S25+" is s25plus, never s25 (S23 titles say "S23 Plus") */
  function devKey(t) { return canon(String(t || '').replace(DEV_TAIL, '').replace(/\+/g, ' plus ')); }
  function devOf(title) {
    var parts = String(title || '').split(' - ');
    return parts.length > 1 ? devKey(parts[parts.length - 1]) : '';
  }
  /* the remembered phone (read only; mf-device.js writes the record) */
  function remembered() {
    if (!DEVICE_SCOPE) { return null; }
    try {
      var o = JSON.parse(W.localStorage.getItem('mf_dev1') || 'null');
      if (!o || o.v !== 1 || !o.l) { return null; }
      if (!o.t || (new Date().getTime() - o.t) > DEV_TTL) { return null; }
      var l = trim(o.l), k = devKey(l);
      return k ? { l: l, key: k } : null;
    } catch (e) { return null; }
  }
  function namesPhone(q) { return DEV_WORDS.test(q) || DEV_MODEL.test(trim(q)) || DEV_TOKEN.test(q); }
  function markOf(title) { return trim(String(title || '').split(' - ')[0]); }

  function cfg(r) {
    if (r.__upCfg) { return r.__upCfg; }
    var list = function (a) {
      return (r.getAttribute(a) || '').split(',').map(trim).filter(function (x) { return !!x; });
    };
    var hidden = {};
    list('data-hidden').forEach(function (h) { hidden[h] = 1; });
    var ref = trim(String(r.getAttribute('data-ref-dev') || '').replace(DEV_TAIL, '').replace(/^Apple\s+/i, ''));
    r.__upCfg = {
      suggest: r.getAttribute('data-suggest-url') || '/search/suggest.json',
      search: r.getAttribute('data-search-url') || '/search',
      ref: ref && devKey(ref) ? { l: ref, key: devKey(ref) } : null,
      hidden: hidden,
      hideColls: list('data-hide-colls'),
      shineTag: r.getAttribute('data-shine-tag') || '',
      shineColls: list('data-shine-colls').map(function (x) { return x.toLowerCase().replace(/[^a-z0-9]+/g, '-'); }),
      skip: r.getAttribute('data-skip-ids') || '|'
    };
    return r.__upCfg;
  }
  function allUrl(c, q) { return c.search + '?q=' + encodeURIComponent(q); }

  /* ── the list rules (sections/up-search-results.liquid, snippets/dcard): what the JSON alone can decide ── */
  function listed(c, p) {
    if (!p || !p.handle) { return false; }
    if (c.skip.indexOf('|' + p.id + '|') >= 0) { return false; }
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    if (tags.indexOf('nanoglass') >= 0) { return false; }
    if (c.hidden[p.handle]) { return false; }
    return true;
  }
  /* ... and what needs the product's collections (the hidden collections past the first 50 the snippet can list,
     and the shine hide tag, which a shine collection lifts) */
  function hiddenByColls(c, p, e) {
    var i;
    for (i = 0; i < c.hideColls.length; i++) { if (e.colls[c.hideColls[i]]) { return true; } }
    if (c.shineTag && (p.tags || []).indexOf(c.shineTag) >= 0) {
      for (i = 0; i < c.shineColls.length; i++) { if (e.colls[c.shineColls[i]]) { return false; } }
      return true;
    }
    return false;
  }

  /* ── the mockup's searchDesigns(): every typed word (or its synonym, or without a plural s) in the title or tags ── */
  function words(q) { return norm(q).split(' ').filter(function (w) { return !!w; }); }
  function matches(p, ws) {
    var hay = norm(String(p.title || '') + ' ' + (p.tags || []).join(' '));
    return ws.every(function (w) {
      var alts = SYN[w] ? [w, SYN[w]] : [w];
      return alts.some(function (a) { return hay.indexOf(a) >= 0 || (a.length > 3 && hay.indexOf(a.replace(/s$/, '')) >= 0); });
    });
  }
  function onPhone(ps, key) {
    if (!key) { return null; }
    for (var i = 0; i < ps.length; i++) { if (devOf(ps[i].title) === key) { return ps[i]; } }
    return null;
  }
  /* The phone query's links carry the variant its words matched ("iPhone 17 Pro Max" -> the Pro-Shock variant, often
     a sold-out one): those products link to the product page as it opens by itself. The typed words' own links keep
     theirs, as live ("magsafe" opens the MagSafe variant). */
  function plainLink(p) {
    var o = {}, k;
    for (k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) { o[k] = p[k]; } }
    o.url = String(p.url || '').replace(/([?&])variant=[^&#]*&?/, '$1').replace(/[?&]$/, '');
    return o;
  }
  /* the two answers -> one product per design, in the order the typed words found them (the plain answer first) */
  function pick(c, plain, scoped, q, own, ref) {
    var seen = {}, pool = [];
    [plain || [], scoped || []].forEach(function (ps, i) {
      ps.forEach(function (p) {
        if (listed(c, p) && !seen[p.handle]) { seen[p.handle] = 1; pool.push(i ? plainLink(p) : p); }
      });
    });
    var ws = words(q), hits = pool.filter(function (p) { return matches(p, ws); });
    if (!hits.length) {
      /* nothing carries every typed word (the engine matched a synonym or a description): its own answer to the
         typed words, as live - never the phone query's answer (mostly the phone's other designs), never claimed */
      hits = (plain || []).filter(function (p) { return listed(c, p); });
      own = null;
    }
    var by = {}, order = [];
    hits.forEach(function (p) {
      var k = markOf(p.title).toLowerCase();
      if (!by[k]) { by[k] = []; order.push(k); }
      by[k].push(p);
    });
    if (own) {
      var mine = order.filter(function (k) { return !!onPhone(by[k], own.key); });
      if (mine.length) { return { list: mine.map(function (k) { return onPhone(by[k], own.key); }), dev: own }; }
    }
    /* no claim: as many cards as the answers allow on one phone - the asked one, else the one most designs come on */
    var per = {}, modal = '', top = 0;
    order.forEach(function (k) {
      var had = {};
      by[k].forEach(function (p) {
        var d = devOf(p.title);
        if (!d || had[d]) { return; }
        had[d] = 1; per[d] = (per[d] || 0) + 1;
        if (per[d] > top) { top = per[d]; modal = d; }
      });
    });
    var want = own ? own.key : (ref ? ref.key : '');
    return {
      list: order.map(function (k) { return onPhone(by[k], want) || onPhone(by[k], modal) || by[k][0]; }),
      dev: null
    };
  }

  function suggest(c, q) {
    var url = c.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10';
    if (cache[url]) { return Promise.resolve(cache[url]); }
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('suggest ' + r.status); } return r.json(); })
      .then(function (d) {
        var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        cache[url] = ps;
        return ps;
      });
  }
  function find(c, q) {
    var named = namesPhone(q), own = named ? null : remembered(), ref = named ? null : c.ref;
    var phone = own || ref;
    var soft = function (pr) { return pr.then(null, function () { return null; }); };
    return Promise.all([soft(suggest(c, q)), phone ? soft(suggest(c, q + ' ' + phone.l)) : Promise.resolve(null)])
      .then(function (a) {
        if (!a[0] && !a[1]) { throw new Error('suggest'); }
        return pick(c, a[0], a[1], q, own, ref);
      });
  }

  function digest(n) {
    var colls = {}, vs = (n.variants && n.variants.nodes) || [], v = null, i;
    ((n.collections && n.collections.nodes) || []).forEach(function (x) { colls[x.handle] = 1; });
    for (i = 0; i < vs.length; i++) { if (vs[i].availableForSale) { v = vs[i]; break; } }
    return { colls: colls, v: v || vs[0] || null };   /* = product.selected_or_first_available_variant */
  }
  /* one tokenless Storefront query; a failed or empty answer is asked once more */
  function gql(query, tries) {
    return fetch(GQL, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (!d || !d.data) { throw new Error('gql'); } return d.data; })
      .then(null, function () {
        if (tries <= 1) { return null; }
        return new Promise(function (res) { W.setTimeout(res, 300); }).then(function () { return gql(query, tries - 1); });
      });
  }
  /* ready: settles with the answer or after ENRICH_WAIT, whichever is first; done: true when the answer came after
     that, so the caller repaints the cards once more with the chip and the spec */
  function enrich(ps) {
    var need = ps.filter(function (p) { return !Object.prototype.hasOwnProperty.call(extra, p.handle); });
    if (!need.length) { return { ready: Promise.resolve(), done: Promise.resolve(false) }; }
    var query = 'query {' + need.map(function (p, i) {
      return ' p' + i + ': product(handle: ' + JSON.stringify(String(p.handle)) + ') { ...U }';
    }).join('') + ' } ' + GQL_FRAG;
    var slow = false;
    var got = gql(query, 2).then(function (data) {
      if (!data) { return; }
      need.forEach(function (p, i) { extra[p.handle] = data['p' + i] ? digest(data['p' + i]) : null; });
    });
    var wait = new Promise(function (res) { W.setTimeout(function () { slow = true; res(); }, ENRICH_WAIT); });
    return { ready: Promise.race([got, wait]), done: got.then(function () { return slow; }) };
  }

  /* snippets/up-card.liquid, built from the suggest JSON (+ the Storefront completion). No data-g: a search is an
     explicit intent, so results are not filtered by the gender lens (live search never was; the search page agrees). */
  function card(c, p, e) {
    var mark = markOf(p.title), name = mark.slice(-4) === ' 2.0' ? mark.slice(0, -4) : mark;
    var price, cmp, type = '';
    if (e && e.v) {
      price = parseFloat(e.v.price && e.v.price.amount);
      cmp = e.v.compareAtPrice ? parseFloat(e.v.compareAtPrice.amount) : 0;
      type = (e.v.selectedOptions && e.v.selectedOptions[0] && e.v.selectedOptions[0].value) || '';
    } else {
      price = parseFloat(p.price);
      cmp = parseFloat(p.compare_at_price_min) || 0;
    }
    type = type.replace(' MagSafe', '').replace(' Transparent', '');
    var spec = type === 'Full-Shock' ? t('up.nav.spec_full') : type === 'Pro-Shock' ? t('up.nav.spec_pro') : '';
    var off = (!W.__mfFP && cmp > price) ? Math.round((cmp - price) * 100 / cmp) : 0;
    var p11 = !!(e && e.colls['all-cases']);
    var im = (p.featured_image && p.featured_image.url) || p.image || '';
    var at = function (w) { return im + (im.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; };
    var alt = (p.featured_image && p.featured_image.alt) || p.title;
    return '<a class="u-card" href="' + esc(p.url) + '" data-mark="' + esc(mark) + '" data-p11="' + (p11 ? 1 : 0) + '">' +
      '<div class="u-hd"><div class="u-nm">' + esc(name) + '</div>' + (spec ? '<span class="u-spec">' + esc(spec) + '</span>' : '') + '</div>' +
      '<div class="u-gloss u-nogloss u-matte">' + (im ? '<img src="' + esc(at(500)) + '" srcset="' + esc(at(300)) + ' 300w, ' + esc(at(500)) +
        ' 500w" sizes="(min-width: 760px) 220px, 44vw" alt="' + esc(alt) + '" width="500" height="750" loading="lazy">' : '') + '</div>' +
      '<div class="u-row">' + (off > 0 ? '<span class="u-off">&minus;' + off + '%</span>' : '<span></span>') +
        (p11 && p11Arm() ? '<span class="u-chip">' + esc(t('up.nav.p11_chip')) + '</span>' : '') + '</div></a>';
  }

  /* ── the empty sheet: vibes and most-searched cards for this face (rebuilt only when the face changed) ── */
  function build(r) {
    var f = face(), pool = one(r, 'template[data-u-spool]');
    if (!pool || r.__upFace === f) { return; }
    r.__upFace = f;
    var src = pool.content, i, n;
    var vb = one(r, '[data-u-svibes]'), tiles = src.querySelectorAll('[data-u-vibe]');
    if (vb) {
      vb.innerHTML = '';
      for (i = 0, n = 0; i < tiles.length && n < VIBES; i++) {
        if ((tiles[i].getAttribute('data-f') || '').indexOf(f) < 0) { continue; }
        vb.appendChild(tiles[i].cloneNode(true)); n++;
      }
    }
    var rail = one(r, '[data-u-spopular]'), cards = src.querySelectorAll('.u-card');
    if (rail) {
      rail.innerHTML = '';
      for (i = 0, n = 0; i < cards.length && n < POPULAR; i++) {
        var g = cards[i].getAttribute('data-g') || '';
        if ((f === 'w' && g === 'm') || (f === 'm' && g === 'w')) { continue; }
        rail.appendChild(cards[i].cloneNode(true)); n++;
      }
    }
  }
  function vibesFor(r, q) {
    var nq = norm(q), out = [], tiles, f = face(), i;
    if (nq.length < 2) { return out; }
    tiles = one(r, 'template[data-u-spool]');
    tiles = tiles ? tiles.content.querySelectorAll('[data-u-vibe]') : [];
    for (i = 0; i < tiles.length && out.length < VIBES; i++) {
      if ((tiles[i].getAttribute('data-f') || '').indexOf(f) < 0) { continue; }
      if (norm(tiles[i].getAttribute('data-t')).indexOf(nq) >= 0 || norm(tiles[i].getAttribute('data-u-vibe')).indexOf(nq) >= 0) {
        out.push(tiles[i].outerHTML);
      }
    }
    return out;
  }

  function view(r, html) {
    var empty = one(r, '[data-u-sempty]'), res = one(r, '[data-u-sres]');
    if (html == null) { empty.hidden = false; res.hidden = true; res.innerHTML = ''; return; }
    res.innerHTML = html; res.hidden = false; empty.hidden = true;
  }
  function none(r, q) {
    build(r);
    var chips = one(r, '[data-u-spop]'), rail = one(r, '[data-u-spopular]');
    return '<div class="u-s-none"><div class="u-dot">0</div><div><h3>' + esc(t('up.nav.none_title')).replace(/\[q\]/g, function () { return esc(q); }) + '</h3>' +
      '<p class="u-lead">' + esc(t('up.nav.none_lead')) + '</p></div>' +
      '<div class="u-pop u-big">' + (chips ? chips.innerHTML : '') + '</div>' +
      '<div class="u-rail">' + (rail ? rail.innerHTML : '') + '</div></div>';
  }

  function paint(r, c, q, res, cand) {
    var shown = [], dropped = 0;
    cand.forEach(function (p) {
      var e = extra[p.handle];
      if (e && hiddenByColls(c, p, e)) { dropped++; return; }
      if (!e && c.shineTag && (p.tags || []).indexOf(c.shineTag) >= 0) { dropped++; return; }
      if (shown.length < CARDS) { shown.push(card(c, p, e)); }
    });
    var n = res.list.length - dropped, vib = vibesFor(r, q), all = esc(allUrl(c, q));
    if (!n && !vib.length) { view(r, none(r, q)); return; }
    /* the mockup: "N designuri pentru <phone>" (the designs found), "Vezi toate" only past four cards,
       "Vezi toate cele N rezultate" (up.nav.n_designs_*, designs_for, see_result, see_all_n_*) */
    var found = esc(plural('up.nav.n_designs', n)), lbl = found;
    if (res.dev) {
      lbl = esc(t('up.nav.designs_for')).replace(/\[designs\]/g, function () { return found; })
        .replace(/\[device\]/g, function () { return esc(res.dev.l); });
    }
    var cta = esc(n === 1 ? t('up.nav.see_result') : plural('up.nav.see_all_n', n));
    view(r, '<div class="u-s-res">' +
      '<div class="u-s-reshead"><div class="u-lbl">' + lbl + '</div>' +
        (n > CARDS ? '<a class="u-more" href="' + all + '">' + esc(t('up.nav.see_all')) + '</a>' : '') + '</div>' +
      (shown.length ? '<div class="u-s-cards">' + shown.join('') + '</div>' : '') +
      (vib.length ? '<div class="u-lbl">' + esc(t('up.nav.vibe')) + '</div><div class="u-svibes">' + vib.join('') + '</div>' : '') +
      (n ? '<a class="u-cta u-allres" href="' + all + '">' + cta + ' <span class="u-arr">→</span></a>' : '') +
      '</div>');
  }

  function run(r, q) {
    var c = cfg(r), my = ++seq;
    r.setAttribute('aria-busy', 'true');
    find(c, q).then(function (res) {
      if (my !== seq) { return null; }
      var cand = res.list.slice(0, CARDS + 2), job = enrich(cand);
      var go = function () { if (my === seq) { paint(r, c, q, res, cand); } };
      job.done.then(function (late) { if (late) { go(); } });
      return job.ready.then(go);
    }).then(null, function () {
      /* the predictive endpoint failed: the page search still works */
      if (my !== seq) { return; }
      view(r, '<div class="u-s-res"><a class="u-cta u-allres" href="' + esc(allUrl(c, q)) + '">' + esc(t('up.nav.all_results')) + ' <span class="u-arr">→</span></a></div>');
    }).then(function () { if (my === seq) { r.removeAttribute('aria-busy'); } });
  }

  function typed(r, v) {
    var q = trim(v), clr = one(r, '[data-u-sclear]'), res = one(r, '[data-u-sres]');
    if (clr) { clr.hidden = !v; }
    W.clearTimeout(timer);
    if (!q) { seq++; r.removeAttribute('aria-busy'); view(r, null); return; }
    /* the mockup leaves the empty view at the first letter: the results head shows at once, the cards follow */
    if (res && res.hidden) { view(r, '<div class="u-s-res"><div class="u-s-reshead"><div class="u-lbl">' + esc(t('up.nav.searching')) + '</div></div></div>'); }
    timer = W.setTimeout(function () { run(r, q); }, WAIT);
  }

  /* ── accessibility: the openers' state, Tab kept inside while open, the focus back to the opener on close ── */
  function openers(v) {
    [].forEach.call(D.querySelectorAll('[data-u-open="search"]'), function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }
  function focusables(r) {
    return [].filter.call(r.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (x) { return !x.closest('[hidden]') && x.getClientRects().length > 0; });
  }
  openers(false);

  /* ── wiring: everything delegated, so a header re-render (theme editor) needs nothing ── */
  D.addEventListener('u:panel-open', function (e) {
    if (!e.detail || e.detail.id !== 'search') { return; }
    var r = sheet();
    if (!r) { return; }
    r.classList.add('open');            /* .glossy-search.open: assets/mf-popup-game.js waits while search is open */
    openers(true);
    build(r);
    var inp = one(r, '#u-sq');
    if (inp) { try { inp.focus({ preventScroll: true }); } catch (x) { inp.focus(); } }
    var now = new Date().getTime();
    if (now - lastOpen > 800 && typeof W.mfTrackPush === 'function') {
      W.mfTrackPush('mf_search_step', { mf_step: 'sheet_open' });
    }
    lastOpen = now;
  });
  D.addEventListener('u:panel-close', function (e) {
    if (!e.detail || e.detail.id !== 'search') { return; }
    var r = sheet(), a = D.activeElement;
    openers(false);
    if (!r) { return; }
    r.classList.remove('open');
    if (opener && D.documentElement.contains(opener) && (!a || a === D.body || r.contains(a))) {
      try { opener.focus({ preventScroll: true }); } catch (x) {}
    }
  });
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || e.defaultPrevented) { return; }
    var r = sheet();
    if (!r || !r.classList.contains('u-on')) { return; }
    var f = focusables(r), a = D.activeElement, i = f.indexOf(a);
    if (!f.length) { return; }
    if (!r.contains(a)) { e.preventDefault(); f[0].focus(); return; }
    if (e.shiftKey && (i === 0 || a === r)) { e.preventDefault(); f[f.length - 1].focus(); return; }
    if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
  });
  D.addEventListener('input', function (e) {
    if (!e.target || e.target.id !== 'u-sq') { return; }
    var r = sheet();
    if (r) { typed(r, e.target.value); }
  });
  D.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var o = t.closest('[data-u-open="search"]');
    if (o) { opener = o; return; }
    var r = sheet();
    if (!r || !r.contains(t)) { return; }
    var inp = one(r, '#u-sq'), chip = t.closest('[data-u-q]');
    if (chip && inp) {
      /* the mockup's data-q: the chip becomes the query and searches in the sheet */
      e.preventDefault();
      inp.value = chip.getAttribute('data-u-q');
      typed(r, inp.value);
      try { inp.focus({ preventScroll: true }); } catch (x) {}
      r.querySelector('[data-u-sbody]').scrollTop = 0;
      return;
    }
    if (t.closest('[data-u-sclear]') && inp) {
      e.preventDefault();
      inp.value = '';
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.focus();
    }
  });
  /* Enter = the search page (the form's own GET /search?q=); an empty query goes nowhere */
  D.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute || !f.hasAttribute('data-u-sform')) { return; }
    var inp = f.querySelector('#u-sq'), q = inp ? trim(inp.value) : '';
    if (!q) { e.preventDefault(); return; }
    inp.value = q;
  });
  /* theme editor: selecting the Glossy Search block shows the sheet */
  D.addEventListener('shopify:block:select', function (e) {
    if (e.target && e.target.id === 'search' && W.upPanel) { W.upPanel.open('search'); }
  });
  D.addEventListener('shopify:block:deselect', function (e) {
    if (e.target && e.target.id === 'search' && W.upPanel) { W.upPanel.close(); }
  });
})();
